import GoogleFontLoader from "react-google-font-loader";

export default function NewFeedPostStatus({ post }: { post: any }) {
  let textPost = JSON.parse(post?.media_style);

  if (!textPost) return <></>;

  let subStringBackgroundColor: string = textPost?.background_color;
  let subStringColor: string = textPost?.text_style?.color;

  if (subStringBackgroundColor.length && subStringColor.length === 8) {
    subStringBackgroundColor = subStringBackgroundColor.substring(2);
    subStringColor = subStringColor.substring(2);
  } else {
    subStringColor = "ffffff";
    subStringBackgroundColor = "000000";
  }

  const textSize = textPost?.text_style?.font_size * 0.65;

  return (
    <div
      style={{
        aspectRatio: `1`,
        overflow: "hidden",
        backgroundColor: `#${subStringBackgroundColor}`,
      }}
      className="flex items-center text-center justify-center"
    >
      <GoogleFontLoader
        fonts={[{ font: `${textPost?.text_style?.font}`, weights: [400] }]}
      />
      <p
        style={{
          color: `#${subStringColor}`,
          fontSize: textSize,
          fontFamily: `${textPost?.text_style?.font}, sans-serif`,
        }}
        className="text-center whitespace-pre-line"
      >
        {textPost?.text}
      </p>
    </div>
  );
}

